<script>
  import ApplicationState from "../../../../Stores/applicationStates"
  import { push } from "svelte-spa-router"
  import Navbar from "../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../Shared/footer.svelte"

  let animate = [
    {
      ball1: Math.random() * 100,
      delay: Math.random() * 7 + 1,
    },
    {
      ball2: Math.random() * 100,
      delay: Math.random() * 4 + 1,
    },
    {
      ball3: Math.random() * 100,
      delay: Math.random() * 11 + 1,
    },
    {
      ball4: Math.random() * 100,
      delay: Math.random() * 1 + 1,
    },
  ]

  let array = []

  const addCircle = () => {
    let circle = {
      cx: Math.random() * 250,
      cy: 250 + Math.random() * 250,
    }
    array = [...array, circle]
  }
  for (let i = 0; i < 5; i++) {
    setTimeout(addCircle, Math.floor(Math.random() * 3000))
  }
</script>

<svelte:head>
  <title>Settings</title>
</svelte:head>

<div class="relative min-h-screen w-full bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  <div class="px-6">
    <div class="relative mx-auto w-full max-w-[920px] select-none pb-40 pt-6">
      <!-- card left -->
      <div class=" mt-6 flex w-full flex-col justify-center gap-3 mobile:flex-row">
        <div class="{$ApplicationState.secret ? 'relative  border-2 border-green-500' : ''}  flex w-full flex-col items-center gap-3 rounded-md bg-white p-5 dark:bg-lightgray md:w-1/2 lg:w-2/5">
          {#if $ApplicationState.secret}
            <div class="absolute top-20 left-0 z-10 rounded-r-md bg-green-500 px-2 py-1 text-sm font-bold tracking-widest text-white">LINKED</div>
          {/if}
          <h1 class="text-center text-lg font-bold leading-relaxed tracking-wide text-black dark:text-white mobile:text-2xl">2F Authentication</h1>
          <div class="relative flex h-60 w-60 items-center justify-center">
            <div class="circle h-32 w-32 rounded-full border-[#e9e9e9] dark:border-bodyblack">
              <div class="flex h-full w-full items-center justify-center">
                <div class="circle1 h-24 w-24 rounded-full border-[#eeeeee] dark:border-bodyblack">
                  <div class="flex h-full w-full items-center justify-center">
                    <i class="fa-solid fa-shield-check fa-3x text-sky-500" />
                  </div>
                </div>
              </div>

              <div
                on:animationiteration={() => {
                  animate[0].ball1 = Math.random() * (100 - 20)
                }}
                class="circle2 absolute bottom-3 rounded-full bg-[#D9D9D9] dark:bg-gray-500"
                style="right : {animate[0].ball1}%; animation-delay:{animate[0].delay}s"
              />

              <div
                on:animationiteration={() => {
                  animate[1].ball2 = Math.random() * (100 - 20)
                }}
                class="circle2 absolute top-3 rounded-full bg-[#D9D9D9] dark:bg-gray-500"
                style="left : {animate[1].ball2}% ;animation-delay:{animate[1].delay}s"
              />

              <div
                on:animationiteration={() => {
                  animate[2].ball3 = Math.random() * (100 - 20)
                }}
                class="circle2 absolute right-3 rounded-full bg-[#D9D9D9] dark:bg-gray-500"
                style="top : {animate[2].ball3}% ;animation-delay:{animate[2].delay}s"
              />
              <div
                on:animationiteration={() => {
                  animate[3].ball4 = Math.random() * (100 - 20)
                }}
                class="circle2 absolute left-3 rounded-full bg-[#D9D9D9] dark:bg-gray-500"
                style="bottom : {animate[3].ball4}% ;animation-delay:{animate[3].delay}s"
              />
            </div>
            <!-- <div class="absolute right-3 top-10 h-7 w-7 animate-pulse rounded-full bg-[#D9D9D9] dark:bg-bodyblack" />
          <div class=" absolute bottom-12 right-3 h-5 w-5 animate-bounce rounded-full bg-[#D9D9D9] dark:bg-bodyblack" />
          <div class=" absolute bottom-1/4 left-1 h-8 w-8 animate-bounce rounded-full bg-[#D9D9D9] dark:bg-bodyblack" /> -->
          </div>
          <p class="h-10 text-center text-sm font-medium leading-relaxed tracking-wider text-gray-200 mobile:h-20 mobile:text-base">To complete the publishing process, you'll need to link an authenticator app for verification purposes.</p>
          <div class="mt-6">
            <button
              on:click={() => {
                push("/settings/integration/authenticator")
              }}
              class="mx-auto h-9 rounded-md {!$ApplicationState.secret ? 'bg-green-500 hover:bg-green-600 active:bg-green-500' : 'bg-blue-500 hover:bg-blue-600 active:bg-blue-500'}  px-3 text-sm font-medium tracking-wide text-white"
            >
              <i class="fa-solid fa-link fa-1x" />
              &nbsp;Link Authenticator App
            </button>
          </div>
        </div>
        <!-- card right -->
        <div class=" flex w-full flex-col items-center gap-3 rounded-md bg-white p-5 dark:bg-lightgray md:w-1/2 lg:w-2/5">
          <h1 class="text-center text-lg font-bold leading-relaxed tracking-wide text-black dark:text-white mobile:text-2xl">Change Password</h1>
          <div class="relative flex h-60 w-60 items-center justify-center">
            <div class="circle h-32 w-32 rounded-full border-[#e9e9e9] dark:border-bodyblack">
              <div class="flex h-full w-full items-center justify-center">
                <div class="circle1 h-24 w-24 rounded-full border-[#eeeeee] dark:border-bodyblack">
                  <div class="flex h-full w-full items-center justify-center">
                    <i class="fa-solid fa-lock fa-3x text-sky-500" />
                  </div>
                </div>
              </div>
            </div>

            <div
              on:animationiteration={() => {
                animate[0].ball1 = Math.random() * (100 - 20)
              }}
              class="circle2 absolute top-3 rounded-full bg-[#D9D9D9] dark:bg-gray-500"
              style="right : {animate[0].ball1}%; animation-delay:{animate[0].delay}s"
            />

            <div
              on:animationiteration={() => {
                animate[1].ball2 = Math.random() * (100 - 20)
              }}
              class="circle2 absolute bottom-3 rounded-full bg-[#D9D9D9] dark:bg-gray-500"
              style="right : {animate[1].ball2}% ;animation-delay:{animate[1].delay}s"
            />

            <div
              on:animationiteration={() => {
                animate[2].ball3 = Math.random() * (100 - 20)
              }}
              class="circle2 absolute left-3 rounded-full bg-[#D9D9D9] dark:bg-gray-500"
              style="top : {animate[2].ball3}% ;animation-delay:{animate[2].delay}s"
            />
            <div
              on:animationiteration={() => {
                animate[3].ball4 = Math.random() * (100 - 20)
              }}
              class="circle2 absolute right-3 rounded-full bg-[#D9D9D9] dark:bg-gray-500"
              style="top : {animate[3].ball4}% ;animation-delay:{animate[3].delay}s"
            />
            <!-- <div class="absolute bottom-12 right-3 h-8 w-8 animate-bounce rounded-full bg-[#D9D9D9] dark:bg-bodyblack" />
          <div class=" absolute bottom-1/4 left-1 h-5 w-5 animate-bounce rounded-full bg-[#D9D9D9] dark:bg-bodyblack" /> -->
          </div>
          <p class="h-10 text-center text-sm font-medium leading-relaxed tracking-wider text-gray-200 mobile:h-20 mobile:text-base">To ensure the security of your account, it is recommended to change your password regularly.</p>
          <div class="mt-6">
            <button
              on:click={() => {
                push("/settings/security")
              }}
              class="mx-auto h-9 w-full rounded-md bg-blue-500 px-3 text-sm font-medium tracking-wide text-white hover:bg-blue-600 active:bg-blue-500"
            >
              <i class="fa-solid fa-lock fa-1x" />
              &nbsp;Change Password
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer />
</div>

<style lang="postcss">
  /* ring moving animation */
  @keyframes border-animation {
    0% {
      height: 100px;
      width: 100px;
      border-width: 8px;
    }
    50% {
      border-width: 20px;
    }

    100% {
      height: 150px;
      width: 150px;
      border-width: 25px;
    }
  }
  @keyframes card-animation {
    0% {
      height: 96px;
      width: 96px;
    }
    50% {
      height: 84px;
      width: 84px;
    }

    100% {
      height: 110px;
      width: 110px;
    }
  }

  .circle {
    animation: border-animation 3s alternate infinite cubic-bezier(0, 0, 0.5, 1);
  }
  .circle1 {
    animation: card-animation 3s 1s alternate infinite cubic-bezier(0, 0, 0.5, 1);
  }

  /* random balls generation */
  @keyframes card-animation1 {
    0% {
      height: 0px;
      width: 0px;
      opacity: 1;
    }
    100% {
      height: 40px;
      width: 40px;
      opacity: 0.1;
    }
  }

  .circle2 {
    animation: card-animation1 3s infinite linear;
  }
</style>
